export enum HistoryDomen {
    BANK_ACCOUNT = 'BANK_ACCOUNT',
    USER = 'USER',
    PERSON = 'PERSON',
    COMPANY = 'COMPANY',
    SUBLIME_EMPLOYEE = "SUBLIME_EMPLOYEE",
    TIMESHEET_RECORD = 'TIMESHEET_RECORD',
    ADDRESS = 'ADDRESS',
    STATE_ID = "STATE_ID",
    EAD = "EAD",
    CITIZEN_PASSPORT = 'CITIZEN_PASSPORT',
    GREEN_CARD = "GREEN_CARD",
    COMPENSATION = "COMPENSATION"
}